module.exports = __webpack_public_path__ + "beb0346ea0239e7307630e1799e10103.svg";